// src/services/api.js
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const blogApi = createApi({
  reducerPath: 'blogApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_BLOG_URL,
    
  }),
  endpoints: (builder) => ({
    getBlogData: builder.query({
      query: () => '/wp/v2/posts?orderby=date&order=desc',
    }),
    getCategories: builder.query({
      query: () => '/wp/v2/categories',
    }),
    getBlogDetails: builder.query({
      query: (id) => `/wp/v2/posts/${id}`,
    }),
  }),
});

export const { useGetBlogDataQuery, useGetCategoriesQuery, useGetBlogDetailsQuery } = blogApi;
